import {Component, OnInit, Input } from '@angular/core';
import { ExpressionEvaluatorModel } from '../expression-evaluator.model';
import { AbstractWorkflowResultComponent } from '../../@core/abstract-workflow-result.component';

@Component({
    selector: 'abw-expression-evaluator-result',
    templateUrl: './expression-evaluator-result.component.html',
    styleUrls: ['./expression-evaluator-result.component.scss']
})
export class ExpressionEvaluatorResultComponent extends AbstractWorkflowResultComponent<ExpressionEvaluatorModel> {
}

